import { Path, Svg } from 'react-native-svg';

export const SvgPlus = () => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={10}
      height={12}
      fill="red"
      viewBox="0 0 10 12"
    >
      <Path
        fill="#BBB"
        d="M6.035 4.78h3.711v2.167h-3.71v4.229H3.73V6.947H0V4.78h3.73V.824h2.305V4.78Z"
      />
    </Svg>
  );
};
